import React from 'react';

const WhyBest = () => {
    return (
        <div className="mt-5 pt-5 mb-5 pb-5">
            <section >
	  <div className="container">
      <div className="text-center mt-5 pt-5 mb-3">
      <h2>Why we are <span className="text-info">Best</span> </h2>
      <p>Medicinal Service Company puts stock in conveying the most elevated quality administration with quality and sympathy every day.</p>
    </div>
	    <div className="row text-center" >
	      <div className="col-md-12 col-lg-4 col-sm-12 mx-auto g-4">
	        <div className="pt-2 border shadow"><span>
                <img height="75" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4yo4ZZgnP3Z6rAhjfPzT6Y_89aFnQ8-OZjQHuTFfNfGY8KYnYINjGKOpoVB92IvziOmk&usqp=CAU" alt="" />
            </span>
	          <h3 className="title">Online Payment</h3>
	          <p>You can pay with Electronic Fund Transfers System (EFT) easily.</p>
	        </div>
	      </div>
	      <div className="col-md-12 col-lg-4 col-sm-12 g-4">
	        <div className="pt-2 border shadow"> <span>
                <img height="75" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEXyqTBm3LxLqtrFHXBaWF9kPB2aGTHlLGaA&usqp=CAU" alt="" />
            </span>
	          <h3 className="title">24hour Online Help</h3>
	          <p>You Can Call Our Medical Help Line 24 hours a day, In a Week.</p>
	        </div>
	      </div>
	      <div className="col-md-12 col-lg-4 col-sm-12 g-4">
	        <div className="pt-2 border shadow"> <span>
                <img height="75" src="https://cdn-icons-png.flaticon.com/512/1834/1834905.png" alt="" />
            </span>
	          <h3 className="title">Emergency</h3>
	          <p>Hi and welcome we are ready for emergency vehicle administrations and Medical Services.</p>
	        </div>
	      </div>
	    </div>
	  </div>
	</section>
        </div>
    );
};

export default WhyBest;